import React from 'react';
import {
    ExperienceFragmentModel,
    ExperienceServiceResponse,
} from '../../../services/content-service/content-service.interface';
import { useExperienceContent } from '../../../hooks/use-server-content';
import AccordionItem from '../AccordionItem/AccordionItem';
import './support-accordion.scss';
interface SupportAccordionProps {
    contentServiceDirectory: string;
    contentServiceName: string;
    contentServiceComponentName: string;
    header?: string;
    description?: string;
    eventName?: string;
}

export interface AccordionExperienceFragmentResponse
    extends ExperienceServiceResponse {
    ':items': AccordionExperienceFragmentModel;
}
export interface AccordionExperienceFragmentModel
    extends ExperienceFragmentModel {
    [key: string]: any;
}

const SupportAccordion = ({
    contentServiceDirectory,
    contentServiceName,
    contentServiceComponentName,
    header,
    description,
    eventName,
}: SupportAccordionProps) => {
    const [accordionContent] = useExperienceContent<
        AccordionExperienceFragmentResponse
    >(contentServiceDirectory, contentServiceName, contentServiceComponentName);
    const accordions = accordionContent
        ? accordionContent[':itemsOrder']?.map(
              (itemName: string) => accordionContent[':items'][itemName]
          )
        : null;

    return (
        <>
            {!!accordions?.length && (
                <>
                    {header && <h2 className="info-title">{header}</h2>}
                    {description && (
                        <div
                            dangerouslySetInnerHTML={{ __html: description }}
                        ></div>
                    )}
                    <div className="support-accordion">
                        {accordions?.map((accordion, index) => (
                            <AccordionItem
                                title={accordion['cq:panelTitle']}
                                subtitle={' '}
                                key={index}
                                eventName={eventName}
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: accordion.text,
                                    }}
                                />
                            </AccordionItem>
                        ))}
                    </div>
                </>
            )}
        </>
    );
};

export default SupportAccordion;
